import React from "react";
import { useLocation } from "react-router-dom";
import NavOrgContainer from "./components/NavOrgContainer";
import "./UserDropdown.scss";

const UserDropdown = ({ dropdownList, position = "top" }) => {
  const location = useLocation();

  return (
    <div
      className={`user-dropdown user-dropdown--${position}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="user-dropdown__content">
        <NavOrgContainer />
        <div className="user-dropdown__divider"></div>
        <ul className="user-dropdown__list">
          {dropdownList.map((list, index) => {
            const variantClass = list.variant
              ? `user-dropdown__item--${list.variant}`
              : "";

            return (
              <React.Fragment key={list.path || list.text}>
                <li
                  className={`user-dropdown__item ${variantClass} ${
                    location.pathname === list.path ? "user-dropdown__item--active" : ""
                  }`}
                  onClick={list.onClickHandler}
                >
                  {list.text}
                </li>
                {index < dropdownList.length - 1 && (
                  <div className="user-dropdown__divider user-dropdown__divider--item"></div>
                )}
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default UserDropdown;
